import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

/**
 * Skeleton placeholder that reserves vertical space for a summary table + bar chart
 * while async data is loading. Prevents layout shift when content pops in.
 */
export const SummaryPlaceholder = () => (
  <Box mb={3}>
    {/* Section header */}
    <Skeleton variant="text" width="35%" height={32} style={{ marginBottom: 8 }} />
    {/* Table rows */}
    <Skeleton variant="rect" width="100%" height={200} style={{ borderRadius: 4, marginBottom: 16 }} />
    {/* Bar chart */}
    <Skeleton variant="rect" width="100%" height={180} style={{ borderRadius: 4 }} />
  </Box>
);
